export enum AttachmentType {
  Image = 'IMAGE',
  Link = 'LINK'
}

export type Attachment = {
  name?: string
  title?: string
  url: string
  type: AttachmentType
  size?: number
  // set for a file picked offline (base64 payload waiting for sync)
  fileName?: string
  _pending?: boolean
}

export type LinkData = { linkTarget: string; linkName?: string }

export type UploadProgress = { name: string; size: number; progress: number }
